import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=ee8a540e&scoped=true&"
import script from "./ModalWindow.vue?vue&type=script&lang=js&"
export * from "./ModalWindow.vue?vue&type=script&lang=js&"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=ee8a540e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8a540e",
  null
  
)

export default component.exports